import { render, staticRenderFns } from "./taxExports-list.vue?vue&type=template&id=b5ec9134&"
import script from "./taxExports-list.vue?vue&type=script&lang=js&"
export * from "./taxExports-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports